import { css } from "styled-components"

/** px → rem against a 16px root (see global.js). toRem(16) === '1rem'. */
export const toRem = (size) => `${size / 16}rem`

export const toRgba = (rgb, alpha) =>
  `rgba(${rgb.substring(4, rgb.length - 1)},${alpha})`

export const breakpoints = {
  // 1920px
  largeDesktop: "(min-width: 120em)",

  // 1440px
  bigDesktop: "(min-width: 90em)",

  // 1120px
  desktop: "(min-width: 70em)",

  // 1024px
  laptop: "(min-width: 64em)",

  // 850px
  tabletSpec: "(min-width: 53.125em)",

  // 768px
  tablet: "(min-width: 48em)",

  // 600px
  phablet: "(min-width: 37.5em)",

  // 300px
  fromMobile: "(min-width: 18.75em)",

  // 400px
  smallmobileonly: "(max-width: 25em)",

  // 768px
  belowTablet: "(max-width: 48em)",

  // 600px
  mobileonly: "(max-width: 37.5em)",
}

export const pseudo = css`
  content: "";
  display: block;
  position: absolute;
`

export const flex = {
  row: css`
    display: flex;
  `,
  column: css`
    display: flex;
    flex-direction: column;
  `,
  rowCenter: css`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  columnCenter: css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  `,
}

export const position = (pos, left, top, right, bottom) => css`
  position: ${pos};
  left: ${left};
  top: ${top};
  right: ${right};
  bottom: ${bottom};
`
